export default class SubscriptionOpeningHours {
  // NOTE : In Firestore this object is a two entry array
  private _start: number;
  private _end: number;

  constructor(start: number, end: number) {
    this._start = start;
    this._end = end;
  }

  get start(): number {
    return this._start;
  }

  get end(): number {
    return this._end;
  }

  public copyWith({
    start,
    end,
  }: {
    start?: number;
    end?: number;
  }): SubscriptionOpeningHours {
    return new SubscriptionOpeningHours(start ?? this._start, end ?? this._end);
  }

  static fromFirestoreArray(data: number[]): SubscriptionOpeningHours {
    const start = data[0];
    const end = data[1];
    return new SubscriptionOpeningHours(start, end);
  }

  toFirestoreArrayPatch(): number[] {
    return [this._start, this._end];
  }
}
